var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthenticated)?_c('dashboard',{attrs:{"hasNotification":_vm.hasNotification,"notification":_vm.notification}}):_c('router-view'),_c('TheGallery',{ref:"galleryRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }